import React, {useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Redirect, Route, Switch} from 'react-router-dom'
import {PageTitle} from '../../../theme/layout/components/HeadTitle'
import {PageUrl} from '../../utils/common/constants'
import ServiceFirstRun from './components/first-run/ServiceFirstRun'
import ServicePreviewStateBar, {
  ServicePreviewState,
} from './components/first-run/ServicePreviewStateBar'
import B8akCatalogueModal from './components/catalogue-modal/B8akCatalogueModal'
import ServicesPageHeader from './components/page-header/ServicesPageHeader'
import ServiceTree, {ServiceSourceFilters} from './components/service-tree/ServiceTree'
import './components/service-tree/style.scss'
import AddMajorServiceModal from './components/service-form/AddMajorServiceModal'
import './style.scss'
// import { Languages } from '../../utils/common/constants';
// import { B8akToolbar } from 'theme/layout/components';
// import ServiceManagement from './components/ServiceManagement';
// import { useAppSelector } from 'setup/redux/Hooks';
// import { selectLanguage } from '../auth';
// ---------------------------------------------------------------------------

const ServiceManagementPage: React.FC = () => {
  const {t} = useTranslation()
  // The tree owns the category request - the page only reads the count it reports back
  const [previewState, setPreviewState] = useState<ServicePreviewState>('serviceTree')
  const [isCheckingCategories, setIsCheckingCategories] = useState<boolean>(true)
  const hasAutoSelectedStateRef = useRef<boolean>(false)
  const [isCatalogueOpen, setIsCatalogueOpen] = useState<boolean>(false)
  const [isAddCategoryOpen, setIsAddCategoryOpen] = useState<boolean>(false)
  const [categoryReloadToken, setCategoryReloadToken] = useState<number>(0)
  // const language = useAppSelector(selectLanguage);
  // const rtl = language === Languages.ar;
  const handleCategoriesLoaded = (count: number | null) => {
    setIsCheckingCategories(false)

    if (hasAutoSelectedStateRef.current || count === null) {
      return
    }

    hasAutoSelectedStateRef.current = true

    // No category holds a service yet (none at all, or every one has hasService: false)
    if (count === 0) {
      setPreviewState('firstRun')
    }
  }

  // Shared by every flow that can add the company's first service: switch to
  // the tree view and make sure it actually refetches.
  const goToServiceTreeAndReload = () => {
    setCategoryReloadToken((current) => current + 1)
    setPreviewState('serviceTree')
  }

  PageTitle(t('SERVICE_MANAGEMENT_PAGE.PAGE_TITLE'))
  return (
    <>
      <Switch>
        <Route path={PageUrl.SERVICE_MANAGEMENT.ROOT}>
          <div className={isCheckingCategories ? 'service-management__pending' : ''}>
            <ServicePreviewStateBar value={previewState} onChange={setPreviewState} />

            <ServicesPageHeader
              onLoadB8akServices={() => setIsCatalogueOpen(true)}
              onAddServiceCategory={() => setIsAddCategoryOpen(true)}
              addServiceLabelKey={
                previewState === 'serviceTree'
                  ? 'SERVICE_MANAGEMENT_PAGE.FIRST_RUN.ADD_YOUR_SERVICES'
                  : undefined
              }
            />
          </div>

          {!isCheckingCategories && previewState === 'firstRun' && (
            <ServiceFirstRun
              onLoadB8akServices={() => setIsCatalogueOpen(true)}
              onAddServiceCategory={() => setIsAddCategoryOpen(true)}
            />
          )}

          {isCheckingCategories && (
            <div className='service-management__loading'>
              <span className='spinner-border spinner-border-sm' />
            </div>
          )}

          {previewState === 'serviceTree' && (
            <div className={isCheckingCategories ? 'service-management__pending' : ''}>
              <ServiceTree
                reloadToken={categoryReloadToken}
                onCategoriesLoaded={handleCategoriesLoaded}
              />
            </div>
          )}

          <B8akCatalogueModal
            isShow={isCatalogueOpen}
            onHide={() => setIsCatalogueOpen(false)}
            onAddToTree={goToServiceTreeAndReload}
          />

          <AddMajorServiceModal
            isShow={isAddCategoryOpen}
            mode='add'
            onHide={() => setIsAddCategoryOpen(false)}
            onSaved={goToServiceTreeAndReload}
          />

          {/* {previewState === 'serviceTree' && (
                        <>
                            <B8akToolbar title={t('ASIDE_MENU.SERVICES_MANAGEMENT')} />
                            <ServiceManagement />
                        </>
                    )} */}
        </Route>

        <Redirect to={PageUrl.SERVICE_MANAGEMENT.ROOT} />
      </Switch>
    </>
  )
}

export default ServiceManagementPage
